import { Component, ChangeDetectionStrategy, Input, input } from '@angular/core';
import { ActiveUser } from '../../../../shared/models';
import {
  getActiveUserInitials,
  formatActiveUserTimestampFull,
  getActiveUserApplicationLabel,
  getActiveUserFullName,
  getActiveUserApplicationType,
} from '../../../../shared/utils';

import { Popover } from 'primeng/popover';

@Component({
  selector: 'cmg-clear2-ui-active-user-initials',
  templateUrl: './active-user-initials.component.html',
  styleUrls: ['./active-user-initials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Popover],
})
export class ActiveUserInitialsComponent {
  @Input() users: ActiveUser[] = [];
  readonly maxDisplay = input(3);
  readonly showLabel = input(true);
  readonly labelText = input('Active users:');

  get displayedUsers(): ActiveUser[] {
    return this.users.slice(0, this.maxDisplay());
  }

  get remainingCount(): number {
    return Math.max(0, this.users.length - this.maxDisplay());
  }

  get hasRemainingUsers(): boolean {
    return this.remainingCount > 0;
  }

  getInitials(user: ActiveUser): string {
    return getActiveUserInitials(user);
  }

  getFullName(user: ActiveUser): string {
    return getActiveUserFullName(user);
  }

  getApplicationLabel(user: ActiveUser): string {
    return getActiveUserApplicationLabel(user);
  }

  getFormattedTimestamp(user: ActiveUser): string {
    return formatActiveUserTimestampFull(user);
  }

  getAppClass(user: ActiveUser): string {
    const appType = getActiveUserApplicationType(user);
    return `app-${appType}`;
  }
}
